<template>

	<div :class="{'color-picker': true, 'has-form-input': !!formInputInfo}">

		<div>

			<FormInput
				:type="formInputInfo.type||'text'"
				v-model="formInputValue"
				:name="formInputInfo.name||'an-input'"
				:id="formInputInfo.id||''"
				:label="title||''"
				:placeholder="formInputInfo.placeholder||''"
				:min="formInputInfo.min||0"
				:max="formInputInfo.max||100"
				:required="formInputInfo.required||false"
				:noMarginBottom="true"
				:labelStyles="{
					fontSize: '14px',
					opacity: '0.8',
					fontWeight: 'normal'
				}"
				v-if="formInputInfo"
			/>

			<div :class="{'color-picker-inner': true, top: top, right: right, left: left, bottom: bottom, centerx: centerx, centery: centery}" ref="colorPicker">
				<label @click="showColorPicker = !showColorPicker" v-html="title" v-if="title&&!formInputInfo" />
				<div :class="{'color-picker-wrapper': true}">
					<div
						class="color-preview"
						:style="{ backgroundColor: backgroundColour }"
						@click="showColorPicker = !showColorPicker"
					/>
					<div v-if="showColorPicker" class="color-picker-popup">
						<span class="close" @click="showColorPicker = false">x</span>
						<Chrome 
							:value="color"
							@input="updateColour($event)" 
						/>
					</div>
				</div>
			</div>

		</div>

	</div>

</template>

<script>
import { Chrome } from "vue-color";
import Vue from "vue";
import FormInput from "../Form/Input.vue";
export default {
	name: 'ColourPicker',
	components: {
		Chrome,
		FormInput
	},
	props: {
		value: {
			type: String,
			default: ''
		},
		default: {
			type: String,
			default: '#ffffff'
		},
		title: {
			type: String,
			default: 'Colour Picker'
		},
		position: {
			type: String,
			default: 'bottom-right'
		},
		formInput: {
			type: Object,
			default: () => ({})
		}
	},
	watch: {
		formInputValue: {
			handler(newVal) {
				this.$emit('form-input-change', newVal);
			}
		}
	},
	data() {
		return { 
			color: this.value || this.default,
			showColorPicker: false,
			formInputValue: this.formInput.value || ''
		}
	},
	computed: {

		formInputInfo () {

			if ( Object.keys(this.formInput).length > 0 ) {

				return this.formInput;

			}

			return false;

		},
 
		backgroundColour () {

			return this.value || this.default;

		},
		top () {

			return this.position.includes('top');

		},
		right () {

			return this.position.includes('right');

		},
		left () {

			return this.position.includes('left');

		},
		bottom () {

			return this.position.includes('bottom');

		},
		centerx () {

			return this.position.split('-')[1] === 'center';

		},
		centery () {

			return this.position.split('-')[0] === 'center';

		}

	},
	methods: {

		updateColour(color) {
			Vue.set(this, 'color', color.hex);
			this.$emit('input', color.hex);
			this.$emit('change', color.hex);
		},

		handleClickOutside(event) {
			const colorPicker = this.$refs.colorPicker;
			if (colorPicker && !colorPicker.contains(event.target)) {
				this.showColorPicker = false;
			}
		}

	},
	mounted() {
		document.addEventListener('click', this.handleClickOutside);
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleClickOutside);
	}
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';

.color-picker {

	position: relative;
	overflow: visible;

	> div {
		position: relative;
	}

	label {
		display: block;
		margin-bottom: 0.15rem;
		font-size: 14px !important;
		opacity: 0.8 !important;
		font-weight: normal !important;
	}

	.color-preview {
		width: 30px;
		height: 30px;
		border-radius: 4px;
		border: 1px solid #ddd;
		cursor: pointer;
	}

	.color-picker-wrapper {
		overflow: visible;
		position: relative;
	}

	.color-picker-popup {
		position: absolute;
		z-index: 100;
		bottom: 40px;
		left: 40px;
		margin-top: 5px;
		background: white;
		border-radius: 4px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		padding: 10px;
		width: 245px;
		.close {
			position: absolute;
			top: -15px;
			right: -10px;
			width: 20px;
			height: 20px;
			cursor: pointer;
		}
	}
	.color-picker-inner {
		position: relative;
		overflow: visible;
		&.bottom {
			.color-picker-popup {
				bottom: auto;
				top: 30px;
			}
		}
		&.left {
			.color-picker-popup {
				left: -250px;
			}
		}
		&.centerx {
			.color-picker-popup {
				left: 15px;
				transform: translateX(-50%);
			}
		}
		&.centery {
			.color-picker-popup {
				top: 30px;
				bottom: auto;
				transform: translateY(-50%);
			}
		}
	}

	&.has-form-input {

		position: relative;
		
		.color-picker-inner {
			position: absolute;
			bottom: 4px;
			right: 5px;
		}

	}
}
@media screen and (min-width: 768px) {
	
}

</style>